import stringHash from "string-hash";

import type {ProfileModelType} from "#shared-package/profile-model.ts";

/**
 * Helper to generate user-specific dismiss keys.
 *
 * By making dismiss keys user specific this avoids a situation where one user
 * could dismiss a site banner would prevent another user using the same machine
 * from seeing that banner.
 *
 * NOTE: This doesn't do anything to address the issue of logged-out users
 * dismissing banners from affect what banners other logged out users see.
 */
export const getBaseKey = (
    bannerName: string,
    profile?: ProfileModelType | null,
): string => {
    return profile
        ? `${bannerName}_${stringHash(profile.get("kaid"))}`
        : bannerName;
};

export const getDismissKey = (
    bannerName: string,
    profile?: ProfileModelType | null,
): string => {
    return getBaseKey(bannerName, profile);
};

/**
 * Generate key for storing the timestamp when a banner is shown.
 */
export const getBannerShownKey = (
    bannerName: string,
    profile: ProfileModelType | null,
) => {
    const baseKey = getBaseKey(bannerName, profile);
    return `${baseKey}_shown`;
};
